import { tss } from 'tss-react/mui';

export const useStyles = tss.withName('LayoutMain').create(() => ({
  root: {
    flex: 1
  }
}));
